// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3DG4J{width:100%;overflow:auto}._1pvpY{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}@media(max-width:767px){._1pvpY{-ms-flex-wrap:nowrap;flex-wrap:nowrap;overflow:auto}}", ""]);
// Exports
exports.locals = {
	"root": "_3DG4J",
	"content": "_1pvpY"
};
module.exports = exports;
